module.exports = __webpack_public_path__ + "static/media/diktat-24.4515b1df.mp3";